<template>
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2120_422)">
            <path
                d="M2.55628 3.54567L2.55609 3.54567L0.777779 3.54567C0.605958 3.54567 0.466667 3.68496 0.466667 3.85678L2.55628 3.54567ZM2.55628 3.54567L3.50507 3.5453L3.50525 3.5453L8.5502 3.5453C8.72202 3.5453 8.86131 3.68459 8.86131 3.85641L8.86131 5.32061L8.86133 8.65577V13.7219C8.86133 13.8937 8.72205 14.033 8.55023 14.033L0.777812 14.0333M2.55628 3.54567L0.777812 14.0333M0.777812 14.0333C0.605985 14.0333 0.466689 13.894 0.466688 13.7222L0.466667 3.85678L0.777812 14.0333Z"
                stroke="#F9F9F9" stroke-width="0.933333" />
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.44977 0.500369H7.22809L8.17706 0.5H13.2222C13.6517 0.5 14 0.848223 14 1.27778V2.74197L14 6.07714L14 11.1432C14 11.5728 13.6518 11.921 13.2222 11.921L10.3576 11.9211V10.9878L13.0667 10.9877L13.0667 6.07714L13.0666 2.74197V1.43333L8.17743 1.43333L8.17706 1.43333L7.22845 1.4337L7.22809 1.4337L5.60533 1.4337L5.60533 2.09164H4.672L4.672 1.27815C4.672 0.848594 5.02022 0.500369 5.44977 0.500369Z"
                fill="#F9F9F9" />
        </g>
        <defs>
            <clipPath id="clip0_2120_422">
                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>

</template>